import { render, staticRenderFns } from "./TrustPilotFeatured.vue?vue&type=template&id=242e9bd9&scoped=true&"
import script from "./TrustPilotFeatured.vue?vue&type=script&lang=ts&"
export * from "./TrustPilotFeatured.vue?vue&type=script&lang=ts&"
import style0 from "./TrustPilotFeatured.vue?vue&type=style&index=0&id=242e9bd9&prod&lang=scss&scoped=true&"
import style1 from "./TrustPilotFeatured.vue?vue&type=style&index=1&id=242e9bd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e9bd9",
  null
  
)

export default component.exports